var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 74,
    viewBox: "0 0 85 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.426 21L52.2166 21L21.0067 21C20.451 21 20 21.4246 20 21.9476V30.4738L20 47.5264V56.0527C20 56.5756 20.451 57 21.0067 57L83.426 57C83.9817 57 84.4327 56.5756 84.4327 56.0527V21.9476C84.4327 21.4246 83.9817 21 83.426 21ZM22.0136 46.5788L22.0136 31.4211H28.0542L28.0542 46.5788H22.0136ZM29.0609 48.4737H22.0136V55.1052H51.21V47.4741C46.6857 47.0014 43.1556 43.3814 43.1556 39C43.1556 34.6187 46.6857 30.9986 51.21 30.526V22.8948L22.0136 22.8948V29.5262H29.0609C29.6165 29.5262 30.0675 29.9506 30.0675 30.4738L30.0675 47.5264C30.0675 48.0493 29.6165 48.4737 29.0609 48.4737ZM53.2233 47.4741L53.2233 55.1052L82.4193 55.1052V48.4734H75.3718C74.8161 48.4734 74.3651 48.049 74.3651 47.5261V30.4735C74.3651 29.9506 74.8161 29.5262 75.3718 29.5262H82.4193V22.8948L53.2233 22.8948V30.526C57.7472 30.9988 61.2774 34.6188 61.2774 39C61.2774 43.3813 57.7474 47.0013 53.2233 47.4741ZM53.2233 32.436C56.634 32.8971 59.2637 35.6649 59.2637 39C59.2637 42.3352 56.634 45.103 53.2233 45.5641V32.436ZM51.21 32.436V45.5641C47.7991 45.1031 45.1693 42.3352 45.1693 39C45.1693 35.6649 47.7991 32.897 51.21 32.436ZM76.3787 46.5788H82.4193V31.4211H76.3787V46.5788Z",
    fill: "url(#paint0_linear_358_2306)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_358_2306",
    x1: 83.8034,
    y1: 23.4706,
    x2: 73.2224,
    y2: 27.2065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5000C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveIcon);
export default __webpack_public_path__ + "static/media/live_icon.c7342886ce8bd8061e3950d701ddbacd.svg";
export { ForwardRef as ReactComponent };